import moment from "moment";
export default class OptimizerManager {
	constructor({
		id,
		api_key,
		optimization_api,
		company_id,
		date_end,
		points_per_month,
		points_per_week,
		points_per_day,
		points_total,
		points_subscription_monthly,
		web_enable,
		api_enable,
		service,
	}) {
		this.id = id || 0;
		this.optimization_api = optimization_api || "";
		this.company_id = company_id || "";
		this.api_key = api_key || "";
		this.service = service || "";
		this.date_end = date_end !== undefined ? moment(date_end).format() : new Date();
		this.points_per_month = points_per_month || null;
		this.points_per_week = points_per_week || null;
		this.points_per_day = points_per_day || null;
		this.points_total = points_total || null;
		this.points_subscription_monthly = points_subscription_monthly || null;
		this.web_enable = web_enable || false;
		this.api_enable = api_enable || false;
	}
}
